import { measuredUsingConfigFor as wrap, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getMoistureContentMeasuredUsingConfig from 'Components/Worksheets/MoistureContentWorksheet/measuredUsingConfig';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const initialBalance = wrap(`${prefix}.Equipment.InitialBalance`);
  const washedBalance = wrap(`${prefix}.Equipment.WashedBalance`);

  return mergeConfig(
    {
      [`${prefix}.Masses.InitialTareMass`]: initialBalance,
      [`${prefix}.Masses.InitialTareAndDryMass`]: initialBalance,
      [`${prefix}.Masses.InitialTareAndWetMass`]: initialBalance,
      [`${prefix}.Masses.WashedTareAndDryMass`]: washedBalance,
    },
    getMoistureContentMeasuredUsingConfig(`${prefix}.Masses.MeasuredWashedConstantDryMass`)
  );
};

export default getMeasuredUsingConfig;
